export default "__VITE_ASSET__DEFM4KTq__"